import { useState } from 'react';
import { useLang } from '@/lib/i18n';

export default function AgeGate({ onConfirm }) {
  const [visible, setVisible] = useState(true);
  const { t } = useLang();

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setVisible(false);
    if (onConfirm) onConfirm();
  };

  const handleDeny = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!visible) return null;

  return (
    <div data-testid="age-gate" className="fixed inset-0 z-[9999] bg-black/95 backdrop-blur-2xl flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-full bg-[var(--color-primary)]/10 flex items-center justify-center mx-auto mb-6">
          <span className="text-3xl font-bold text-[var(--color-primary)]">18+</span>
        </div>
        <h2 className="text-xl font-bold text-white mb-3">{t('age.title')}</h2>
        <p className="text-sm text-white/40 mb-8 leading-relaxed">
          {t('age.description')}
        </p>
        <div className="flex flex-col gap-3">
          <button data-testid="age-confirm" onClick={handleConfirm}
            className="w-full py-3 rounded-xl bg-[var(--color-primary)] text-white font-medium hover:opacity-90 transition-opacity">
            {t('age.confirm')}
          </button>
          <button data-testid="age-deny" onClick={handleDeny}
            className="w-full py-3 rounded-xl border border-white/10 text-white/40 hover:text-white hover:border-white/20 transition-colors">
            {t('age.deny')}
          </button>
        </div>
      </div>
    </div>
  );
}
